@file:OptIn(InternalResourceApi::class)

package diana.soleil.design.iraniancanadienbazzar.feature.addbusiness.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String =
    "composeResources/diana.soleil.design.iraniancanadienbazzar.feature.addbusiness.resources/"

@delegate:ResourceContentHash(-74_719_876)
internal val Res.string.ab_back: StringResource by lazy {
      StringResource("string:ab_back", "ab_back", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 47, 31),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 39, 23),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39, 23),
      ))
    }

@delegate:ResourceContentHash(-74_719_876)
internal val Res.string.ab_back_a11y: StringResource by lazy {
      StringResource("string:ab_back_a11y", "ab_back_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10, 36),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 28),
      ))
    }

@delegate:ResourceContentHash(339_358_431)
internal val Res.string.ab_cancel: StringResource by lazy {
      StringResource("string:ab_cancel", "ab_cancel", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 79, 33),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 63, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 63, 25),
      ))
    }

@delegate:ResourceContentHash(339_358_431)
internal val Res.string.ab_dup_cancel: StringResource by lazy {
      StringResource("string:ab_dup_cancel", "ab_dup_cancel", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 113, 37),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 93, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 89, 29),
      ))
    }

@delegate:ResourceContentHash(1_155_282_285)
internal val Res.string.ab_dup_desc: StringResource by lazy {
      StringResource("string:ab_dup_desc", "ab_dup_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 151, 359),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 127, 259),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 119, 219),
      ))
    }

@delegate:ResourceContentHash(948_807_564)
internal val Res.string.ab_dup_submit_anyway: StringResource by lazy {
      StringResource("string:ab_dup_submit_anyway", "ab_dup_submit_anyway", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 511, 76),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 387, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 339, 48),
      ))
    }

@delegate:ResourceContentHash(940_473_700)
internal val Res.string.ab_dup_title: StringResource by lazy {
      StringResource("string:ab_dup_title", "ab_dup_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 588, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 444, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 388, 40),
      ))
    }

@delegate:ResourceContentHash(-2_102_666_236)
internal val Res.string.ab_error_category: StringResource by lazy {
      StringResource("string:ab_error_category", "ab_error_category", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 645, 73),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 489, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 429, 49),
      ))
    }

@delegate:ResourceContentHash(-308_860_774)
internal val Res.string.ab_error_province: StringResource by lazy {
      StringResource("string:ab_error_province", "ab_error_province", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 719, 77),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 551, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 479, 49),
      ))
    }

@delegate:ResourceContentHash(-583_652_916)
internal val Res.string.ab_error_required: StringResource by lazy {
      StringResource("string:ab_error_required", "ab_error_required", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 797, 73),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 609, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 529, 57),
      ))
    }

@delegate:ResourceContentHash(-289_333_079)
internal val Res.string.ab_info_category_label: StringResource by lazy {
      StringResource("string:ab_info_category_label", "ab_info_category_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 871, 58),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 663, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 587, 54),
      ))
    }

@delegate:ResourceContentHash(1_192_754_187)
internal val Res.string.ab_info_category_placeholder: StringResource by lazy {
      StringResource("string:ab_info_category_placeholder", "ab_info_category_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 930, 84),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 722, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 642, 60),
      ))
    }

@delegate:ResourceContentHash(-153_478_507)
internal val Res.string.ab_info_desc_counter: StringResource by lazy {
      StringResource("string:ab_info_desc_counter", "ab_info_desc_counter", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1015, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 791, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 703, 44),
      ))
    }

@delegate:ResourceContentHash(445_225_096)
internal val Res.string.ab_info_desc_helper: StringResource by lazy {
      StringResource("string:ab_info_desc_helper", "ab_info_desc_helper", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1060, 207),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 836, 163),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 748, 135),
      ))
    }

@delegate:ResourceContentHash(1_278_232_219)
internal val Res.string.ab_info_desc_label: StringResource by lazy {
      StringResource("string:ab_info_desc_label", "ab_info_desc_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1268, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1000, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 884, 50),
      ))
    }

@delegate:ResourceContentHash(-1_416_307_966)
internal val Res.string.ab_info_desc_placeholder: StringResource by lazy {
      StringResource("string:ab_info_desc_placeholder", "ab_info_desc_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1323, 172),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1051, 120),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 935, 112),
      ))
    }

@delegate:ResourceContentHash(-1_789_460_562)
internal val Res.string.ab_info_details_label: StringResource by lazy {
      StringResource("string:ab_info_details_label", "ab_info_details_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1496, 93),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1172, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1048, 69),
      ))
    }

@delegate:ResourceContentHash(1_544_048_878)
internal val Res.string.ab_info_name_helper: StringResource by lazy {
      StringResource("string:ab_info_name_helper", "ab_info_name_helper", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1590, 163),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1250, 123),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1118, 107),
      ))
    }

@delegate:ResourceContentHash(2_119_902_976)
internal val Res.string.ab_info_name_label: StringResource by lazy {
      StringResource("string:ab_info_name_label", "ab_info_name_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1754, 58),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1374, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1226, 46),
      ))
    }

@delegate:ResourceContentHash(-759_512_441)
internal val Res.string.ab_info_name_placeholder: StringResource by lazy {
      StringResource("string:ab_info_name_placeholder", "ab_info_name_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1813, 80),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1429, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1273, 72),
      ))
    }

@delegate:ResourceContentHash(1_615_078_601)
internal val Res.string.ab_info_promo: StringResource by lazy {
      StringResource("string:ab_info_promo", "ab_info_promo", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1894, 213),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1506, 141),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1346, 149),
      ))
    }

@delegate:ResourceContentHash(703_597_708)
internal val Res.string.ab_info_tile1_desc: StringResource by lazy {
      StringResource("string:ab_info_tile1_desc", "ab_info_tile1_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2108, 178),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1648, 150),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1496, 118),
      ))
    }

@delegate:ResourceContentHash(-2_018_716_043)
internal val Res.string.ab_info_tile1_title: StringResource by lazy {
      StringResource("string:ab_info_tile1_title", "ab_info_tile1_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2287, 75),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1799, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1615, 55),
      ))
    }

@delegate:ResourceContentHash(-1_493_461_350)
internal val Res.string.ab_info_tile2_desc: StringResource by lazy {
      StringResource("string:ab_info_tile2_desc", "ab_info_tile2_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2363, 202),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1879, 134),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1671, 118),
      ))
    }

@delegate:ResourceContentHash(-1_564_100_979)
internal val Res.string.ab_info_tile2_title: StringResource by lazy {
      StringResource("string:ab_info_tile2_title", "ab_info_tile2_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2566, 71),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2014, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1790, 51),
      ))
    }

@delegate:ResourceContentHash(-1_905_229_859)
internal val Res.string.ab_info_title: StringResource by lazy {
      StringResource("string:ab_info_title", "ab_info_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2638, 81),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2070, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1842, 49),
      ))
    }

@delegate:ResourceContentHash(-371_516_387)
internal val Res.string.ab_intro_add_button: StringResource by lazy {
      StringResource("string:ab_intro_add_button", "ab_intro_add_button", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2720, 79),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2120, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1892, 51),
      ))
    }

@delegate:ResourceContentHash(376_887_623)
internal val Res.string.ab_intro_benefit1_desc: StringResource by lazy {
      StringResource("string:ab_intro_benefit1_desc", "ab_intro_benefit1_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2800, 174),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2180, 126),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1944, 114),
      ))
    }

@delegate:ResourceContentHash(-135_060_093)
internal val Res.string.ab_intro_benefit1_title: StringResource by lazy {
      StringResource("string:ab_intro_benefit1_title", "ab_intro_benefit1_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2975, 95),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2307, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2059, 79),
      ))
    }

@delegate:ResourceContentHash(967_012_813)
internal val Res.string.ab_intro_benefit2_desc: StringResource by lazy {
      StringResource("string:ab_intro_benefit2_desc", "ab_intro_benefit2_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3071, 166),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2395, 150),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2139, 126),
      ))
    }

@delegate:ResourceContentHash(-108_072_558)
internal val Res.string.ab_intro_benefit2_title: StringResource by lazy {
      StringResource("string:ab_intro_benefit2_title", "ab_intro_benefit2_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3238, 111),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2546, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2266, 79),
      ))
    }

@delegate:ResourceContentHash(-1_767_981_477)
internal val Res.string.ab_intro_benefit3_desc: StringResource by lazy {
      StringResource("string:ab_intro_benefit3_desc", "ab_intro_benefit3_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3350, 190),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2634, 146),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2346, 118),
      ))
    }

@delegate:ResourceContentHash(-1_456_160_647)
internal val Res.string.ab_intro_benefit3_title: StringResource by lazy {
      StringResource("string:ab_intro_benefit3_title", "ab_intro_benefit3_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3541, 87),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2781, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2465, 67),
      ))
    }

@delegate:ResourceContentHash(-872_813_652)
internal val Res.string.ab_intro_claim_button: StringResource by lazy {
      StringResource("string:ab_intro_claim_button", "ab_intro_claim_button", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3629, 73),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2853, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2533, 49),
      ))
    }

@delegate:ResourceContentHash(1_056_022_313)
internal val Res.string.ab_intro_claim_desc: StringResource by lazy {
      StringResource("string:ab_intro_claim_desc", "ab_intro_claim_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3703, 251),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2915, 167),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2583, 143),
      ))
    }

@delegate:ResourceContentHash(-104_718_904)
internal val Res.string.ab_intro_claim_placeholder: StringResource by lazy {
      StringResource("string:ab_intro_claim_placeholder", "ab_intro_claim_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3955, 106),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3083, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2727, 78),
      ))
    }

@delegate:ResourceContentHash(-917_874_406)
internal val Res.string.ab_intro_claim_title: StringResource by lazy {
      StringResource("string:ab_intro_claim_title", "ab_intro_claim_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4062, 116),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3162, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2806, 72),
      ))
    }

@delegate:ResourceContentHash(-1_883_463_870)
internal val Res.string.ab_intro_draft_desc: StringResource by lazy {
      StringResource("string:ab_intro_draft_desc", "ab_intro_draft_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4179, 235),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3247, 195),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2879, 147),
      ))
    }

@delegate:ResourceContentHash(1_499_186_467)
internal val Res.string.ab_intro_draft_discard: StringResource by lazy {
      StringResource("string:ab_intro_draft_discard", "ab_intro_draft_discard", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4415, 38),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3443, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3027, 42),
      ))
    }

@delegate:ResourceContentHash(-1_785_837_861)
internal val Res.string.ab_intro_draft_resume: StringResource by lazy {
      StringResource("string:ab_intro_draft_resume", "ab_intro_draft_resume", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4454, 69),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3486, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3070, 45),
      ))
    }

@delegate:ResourceContentHash(2_093_581_748)
internal val Res.string.ab_intro_draft_title: StringResource by lazy {
      StringResource("string:ab_intro_draft_title", "ab_intro_draft_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4524, 104),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3548, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3116, 64),
      ))
    }

@delegate:ResourceContentHash(1_517_391_874)
internal val Res.string.ab_intro_hero_a11y: StringResource by lazy {
      StringResource("string:ab_intro_hero_a11y", "ab_intro_hero_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4629, 86),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3617, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3181, 66),
      ))
    }

@delegate:ResourceContentHash(914_394_128)
internal val Res.string.ab_intro_hero_subtitle: StringResource by lazy {
      StringResource("string:ab_intro_hero_subtitle", "ab_intro_hero_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4716, 290),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3680, 218),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3248, 190),
      ))
    }

@delegate:ResourceContentHash(-865_203_052)
internal val Res.string.ab_intro_hero_title: StringResource by lazy {
      StringResource("string:ab_intro_hero_title", "ab_intro_hero_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5007, 163),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3899, 111),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3439, 91),
      ))
    }

@delegate:ResourceContentHash(868_121_772)
internal val Res.string.ab_intro_learn_more: StringResource by lazy {
      StringResource("string:ab_intro_learn_more", "ab_intro_learn_more", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5171, 131),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4011, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3531, 75),
      ))
    }

@delegate:ResourceContentHash(1_418_143_115)
internal val Res.string.ab_intro_top_title: StringResource by lazy {
      StringResource("string:ab_intro_top_title", "ab_intro_top_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5303, 86),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4099, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3607, 50),
      ))
    }

@delegate:ResourceContentHash(1_228_858_699)
internal val Res.string.ab_lang_autotranslate_hint: StringResource by lazy {
      StringResource("string:ab_lang_autotranslate_hint", "ab_lang_autotranslate_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5390, 406),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4166, 238),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3658, 214),
      ))
    }

@delegate:ResourceContentHash(-761_879_409)
internal val Res.string.ab_lang_tab_a11y: StringResource by lazy {
      StringResource("string:ab_lang_tab_a11y", "ab_lang_tab_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5797, 68),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4405, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3873, 48),
      ))
    }

@delegate:ResourceContentHash(2_024_375_623)
internal val Res.string.ab_lang_will_translate: StringResource by lazy {
      StringResource("string:ab_lang_will_translate", "ab_lang_will_translate", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5866, 174),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4454, 130),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3922, 118),
      ))
    }

@delegate:ResourceContentHash(828_458_534)
internal val Res.string.ab_loc_city_label: StringResource by lazy {
      StringResource("string:ab_loc_city_label", "ab_loc_city_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6041, 33),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4585, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4041, 33),
      ))
    }

@delegate:ResourceContentHash(828_458_534)
internal val Res.string.ab_loc_city_placeholder: StringResource by lazy {
      StringResource("string:ab_loc_city_placeholder", "ab_loc_city_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6075, 39),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4619, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4075, 39),
      ))
    }

@delegate:ResourceContentHash(823_953_510)
internal val Res.string.ab_loc_info: StringResource by lazy {
      StringResource("string:ab_loc_info", "ab_loc_info", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6115, 343),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4659, 255),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4115, 227),
      ))
    }

@delegate:ResourceContentHash(1_813_305_593)
internal val Res.string.ab_loc_map_adjust: StringResource by lazy {
      StringResource("string:ab_loc_map_adjust", "ab_loc_map_adjust", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6459, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4915, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4343, 41),
      ))
    }

@delegate:ResourceContentHash(1_111_835_382)
internal val Res.string.ab_loc_map_title: StringResource by lazy {
      StringResource("string:ab_loc_map_title", "ab_loc_map_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6517, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4965, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4385, 40),
      ))
    }

@delegate:ResourceContentHash(943_187_124)
internal val Res.string.ab_loc_pin_a11y: StringResource by lazy {
      StringResource("string:ab_loc_pin_a11y", "ab_loc_pin_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6582, 39),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5018, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4426, 35),
      ))
    }

@delegate:ResourceContentHash(-840_914_566)
internal val Res.string.ab_loc_postal_label: StringResource by lazy {
      StringResource("string:ab_loc_postal_label", "ab_loc_postal_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6622, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5058, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4462, 43),
      ))
    }

@delegate:ResourceContentHash(-827_762_113)
internal val Res.string.ab_loc_postal_placeholder: StringResource by lazy {
      StringResource("string:ab_loc_postal_placeholder", "ab_loc_postal_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6670, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5102, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4506, 45),
      ))
    }

@delegate:ResourceContentHash(-279_380_346)
internal val Res.string.ab_loc_province_label: StringResource by lazy {
      StringResource("string:ab_loc_province_label", "ab_loc_province_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6716, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5148, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4552, 41),
      ))
    }

@delegate:ResourceContentHash(-1_095_283_039)
internal val Res.string.ab_loc_province_placeholder: StringResource by lazy {
      StringResource("string:ab_loc_province_placeholder", "ab_loc_province_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6762, 87),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5190, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4594, 59),
      ))
    }

@delegate:ResourceContentHash(1_736_926_860)
internal val Res.string.ab_loc_street_label: StringResource by lazy {
      StringResource("string:ab_loc_street_label", "ab_loc_street_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6850, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5254, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4654, 47),
      ))
    }

@delegate:ResourceContentHash(703_984_206)
internal val Res.string.ab_loc_street_placeholder: StringResource by lazy {
      StringResource("string:ab_loc_street_placeholder", "ab_loc_street_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6910, 69),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5306, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4702, 61),
      ))
    }

@delegate:ResourceContentHash(1_810_131_770)
internal val Res.string.ab_location_title: StringResource by lazy {
      StringResource("string:ab_location_title", "ab_location_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6980, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5372, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4764, 49),
      ))
    }

@delegate:ResourceContentHash(-1_322_752_588)
internal val Res.string.ab_next: StringResource by lazy {
      StringResource("string:ab_next", "ab_next", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7046, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5434, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4814, 27),
      ))
    }

@delegate:ResourceContentHash(319_791_594)
internal val Res.string.ab_photos_add_a11y: StringResource by lazy {
      StringResource("string:ab_photos_add_a11y", "ab_photos_add_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7090, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5470, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4842, 38),
      ))
    }

@delegate:ResourceContentHash(-211_844_036)
internal val Res.string.ab_photos_brand_assets: StringResource by lazy {
      StringResource("string:ab_photos_brand_assets", "ab_photos_brand_assets", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7145, 70),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5521, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4881, 46),
      ))
    }

@delegate:ResourceContentHash(1_816_339_196)
internal val Res.string.ab_photos_cover_hint: StringResource by lazy {
      StringResource("string:ab_photos_cover_hint", "ab_photos_cover_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7216, 140),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5580, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4928, 68),
      ))
    }

@delegate:ResourceContentHash(263_562_164)
internal val Res.string.ab_photos_cover_label: StringResource by lazy {
      StringResource("string:ab_photos_cover_label", "ab_photos_cover_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7357, 109),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5677, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4997, 69),
      ))
    }

@delegate:ResourceContentHash(-498_587_294)
internal val Res.string.ab_photos_gallery_hint: StringResource by lazy {
      StringResource("string:ab_photos_gallery_hint", "ab_photos_gallery_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7467, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5759, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5067, 50),
      ))
    }

@delegate:ResourceContentHash(570_737_293)
internal val Res.string.ab_photos_gallery_label: StringResource by lazy {
      StringResource("string:ab_photos_gallery_label", "ab_photos_gallery_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7518, 71),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5814, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5118, 55),
      ))
    }

@delegate:ResourceContentHash(1_143_360_999)
internal val Res.string.ab_photos_logo_button: StringResource by lazy {
      StringResource("string:ab_photos_logo_button", "ab_photos_logo_button", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7590, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5878, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5174, 45),
      ))
    }

@delegate:ResourceContentHash(-1_656_469_503)
internal val Res.string.ab_photos_logo_hint: StringResource by lazy {
      StringResource("string:ab_photos_logo_hint", "ab_photos_logo_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7648, 95),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5928, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5220, 63),
      ))
    }

@delegate:ResourceContentHash(1_410_450_604)
internal val Res.string.ab_photos_logo_label: StringResource by lazy {
      StringResource("string:ab_photos_logo_label", "ab_photos_logo_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7744, 68),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5992, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5284, 48),
      ))
    }

@delegate:ResourceContentHash(957_297_368)
internal val Res.string.ab_photos_preview_a11y: StringResource by lazy {
      StringResource("string:ab_photos_preview_a11y", "ab_photos_preview_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7813, 70),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6049, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5333, 50),
      ))
    }

@delegate:ResourceContentHash(1_217_858_319)
internal val Res.string.ab_photos_proof_button: StringResource by lazy {
      StringResource("string:ab_photos_proof_button", "ab_photos_proof_button", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7884, 62),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6108, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5384, 50),
      ))
    }

@delegate:ResourceContentHash(593_393_470)
internal val Res.string.ab_photos_proof_desc: StringResource by lazy {
      StringResource("string:ab_photos_proof_desc", "ab_photos_proof_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7947, 196),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6171, 156),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5435, 140),
      ))
    }

@delegate:ResourceContentHash(135_031_528)
internal val Res.string.ab_photos_proof_note: StringResource by lazy {
      StringResource("string:ab_photos_proof_note", "ab_photos_proof_note", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 8144, 240),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6328, 164),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5576, 136),
      ))
    }

@delegate:ResourceContentHash(-323_076_067)
internal val Res.string.ab_photos_proof_title: StringResource by lazy {
      StringResource("string:ab_photos_proof_title", "ab_photos_proof_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 8385, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6493, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5713, 53),
      ))
    }

@delegate:ResourceContentHash(1_840_294_903)
internal val Res.string.ab_photos_remove_a11y: StringResource by lazy {
      StringResource("string:ab_photos_remove_a11y", "ab_photos_remove_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 8451, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6551, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5767, 45),
      ))
    }

@delegate:ResourceContentHash(-149_435_757)
internal val Res.string.ab_photos_subtitle: StringResource by lazy {
      StringResource("string:ab_photos_subtitle", "ab_photos_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 8501, 70),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6605, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5813, 66),
      ))
    }

@delegate:ResourceContentHash(-323_144_975)
internal val Res.string.ab_photos_title: StringResource by lazy {
      StringResource("string:ab_photos_title", "ab_photos_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 8572, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6680, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5880, 51),
      ))
    }

@delegate:ResourceContentHash(-175_898_688)
internal val Res.string.ab_photos_verify_b1: StringResource by lazy {
      StringResource("string:ab_photos_verify_b1", "ab_photos_verify_b1", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 8628, 115),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6740, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5932, 67),
      ))
    }

@delegate:ResourceContentHash(2_013_195_860)
internal val Res.string.ab_photos_verify_b2: StringResource by lazy {
      StringResource("string:ab_photos_verify_b2", "ab_photos_verify_b2", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 8744, 71),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6828, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6000, 55),
      ))
    }

@delegate:ResourceContentHash(-964_974_963)
internal val Res.string.ab_photos_verify_b3: StringResource by lazy {
      StringResource("string:ab_photos_verify_b3", "ab_photos_verify_b3", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 8816, 99),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6904, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6056, 67),
      ))
    }

@delegate:ResourceContentHash(1_129_874_136)
internal val Res.string.ab_photos_verify_desc: StringResource by lazy {
      StringResource("string:ab_photos_verify_desc", "ab_photos_verify_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 8916, 177),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6972, 141),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6124, 117),
      ))
    }

@delegate:ResourceContentHash(133_045_348)
internal val Res.string.ab_photos_verify_title: StringResource by lazy {
      StringResource("string:ab_photos_verify_title", "ab_photos_verify_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9094, 62),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7114, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6242, 46),
      ))
    }

@delegate:ResourceContentHash(-2_046_945_693)
internal val Res.string.ab_plan_coming_soon: StringResource by lazy {
      StringResource("string:ab_plan_coming_soon", "ab_plan_coming_soon", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9157, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7177, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6289, 43),
      ))
    }

@delegate:ResourceContentHash(636_152_137)
internal val Res.string.ab_plan_footer: StringResource by lazy {
      StringResource("string:ab_plan_footer", "ab_plan_footer", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9205, 294),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7233, 198),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6333, 174),
      ))
    }

@delegate:ResourceContentHash(388_840_592)
internal val Res.string.ab_plan_founding_note: StringResource by lazy {
      StringResource("string:ab_plan_founding_note", "ab_plan_founding_note", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9500, 493),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7432, 289),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6508, 233),
      ))
    }

@delegate:ResourceContentHash(-100_327_795)
internal val Res.string.ab_plan_free_cta: StringResource by lazy {
      StringResource("string:ab_plan_free_cta", "ab_plan_free_cta", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9994, 72),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7722, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6742, 48),
      ))
    }

@delegate:ResourceContentHash(-1_336_977_241)
internal val Res.string.ab_plan_free_f1: StringResource by lazy {
      StringResource("string:ab_plan_free_f1", "ab_plan_free_f1", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10067, 75),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7787, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6791, 55),
      ))
    }

@delegate:ResourceContentHash(-453_421_348)
internal val Res.string.ab_plan_free_f2: StringResource by lazy {
      StringResource("string:ab_plan_free_f2", "ab_plan_free_f2", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10143, 79),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7847, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6847, 51),
      ))
    }

@delegate:ResourceContentHash(750_494_664)
internal val Res.string.ab_plan_free_f3: StringResource by lazy {
      StringResource("string:ab_plan_free_f3", "ab_plan_free_f3", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10223, 67),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7899, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6899, 47),
      ))
    }

@delegate:ResourceContentHash(1_470_363_306)
internal val Res.string.ab_plan_free_f4: StringResource by lazy {
      StringResource("string:ab_plan_free_f4", "ab_plan_free_f4", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10291, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7963, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6947, 47),
      ))
    }

@delegate:ResourceContentHash(425_122_545)
internal val Res.string.ab_plan_free_name: StringResource by lazy {
      StringResource("string:ab_plan_free_name", "ab_plan_free_name", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10351, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8011, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6995, 41),
      ))
    }

@delegate:ResourceContentHash(85_971_426)
internal val Res.string.ab_plan_free_price: StringResource by lazy {
      StringResource("string:ab_plan_free_price", "ab_plan_free_price", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10397, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8057, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7037, 30),
      ))
    }

@delegate:ResourceContentHash(-1_859_070_460)
internal val Res.string.ab_plan_interest_recorded: StringResource by lazy {
      StringResource("string:ab_plan_interest_recorded", "ab_plan_interest_recorded", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10440, 85),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8088, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7068, 57),
      ))
    }

@delegate:ResourceContentHash(-1_034_686_691)
internal val Res.string.ab_plan_intro: StringResource by lazy {
      StringResource("string:ab_plan_intro", "ab_plan_intro", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10526, 329),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8154, 229),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7126, 217),
      ))
    }

@delegate:ResourceContentHash(-579_402_204)
internal val Res.string.ab_plan_most_popular: StringResource by lazy {
      StringResource("string:ab_plan_most_popular", "ab_plan_most_popular", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10856, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8384, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7344, 44),
      ))
    }

@delegate:ResourceContentHash(378_582_204)
internal val Res.string.ab_plan_notify_me: StringResource by lazy {
      StringResource("string:ab_plan_notify_me", "ab_plan_notify_me", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10913, 105),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8437, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7389, 53),
      ))
    }

@delegate:ResourceContentHash(-2_117_204_649)
internal val Res.string.ab_plan_period_forever: StringResource by lazy {
      StringResource("string:ab_plan_period_forever", "ab_plan_period_forever", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11019, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8495, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7443, 42),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("ab_back", Res.string.ab_back)
  map.put("ab_back_a11y", Res.string.ab_back_a11y)
  map.put("ab_cancel", Res.string.ab_cancel)
  map.put("ab_dup_cancel", Res.string.ab_dup_cancel)
  map.put("ab_dup_desc", Res.string.ab_dup_desc)
  map.put("ab_dup_submit_anyway", Res.string.ab_dup_submit_anyway)
  map.put("ab_dup_title", Res.string.ab_dup_title)
  map.put("ab_error_category", Res.string.ab_error_category)
  map.put("ab_error_province", Res.string.ab_error_province)
  map.put("ab_error_required", Res.string.ab_error_required)
  map.put("ab_info_category_label", Res.string.ab_info_category_label)
  map.put("ab_info_category_placeholder", Res.string.ab_info_category_placeholder)
  map.put("ab_info_desc_counter", Res.string.ab_info_desc_counter)
  map.put("ab_info_desc_helper", Res.string.ab_info_desc_helper)
  map.put("ab_info_desc_label", Res.string.ab_info_desc_label)
  map.put("ab_info_desc_placeholder", Res.string.ab_info_desc_placeholder)
  map.put("ab_info_details_label", Res.string.ab_info_details_label)
  map.put("ab_info_name_helper", Res.string.ab_info_name_helper)
  map.put("ab_info_name_label", Res.string.ab_info_name_label)
  map.put("ab_info_name_placeholder", Res.string.ab_info_name_placeholder)
  map.put("ab_info_promo", Res.string.ab_info_promo)
  map.put("ab_info_tile1_desc", Res.string.ab_info_tile1_desc)
  map.put("ab_info_tile1_title", Res.string.ab_info_tile1_title)
  map.put("ab_info_tile2_desc", Res.string.ab_info_tile2_desc)
  map.put("ab_info_tile2_title", Res.string.ab_info_tile2_title)
  map.put("ab_info_title", Res.string.ab_info_title)
  map.put("ab_intro_add_button", Res.string.ab_intro_add_button)
  map.put("ab_intro_benefit1_desc", Res.string.ab_intro_benefit1_desc)
  map.put("ab_intro_benefit1_title", Res.string.ab_intro_benefit1_title)
  map.put("ab_intro_benefit2_desc", Res.string.ab_intro_benefit2_desc)
  map.put("ab_intro_benefit2_title", Res.string.ab_intro_benefit2_title)
  map.put("ab_intro_benefit3_desc", Res.string.ab_intro_benefit3_desc)
  map.put("ab_intro_benefit3_title", Res.string.ab_intro_benefit3_title)
  map.put("ab_intro_claim_button", Res.string.ab_intro_claim_button)
  map.put("ab_intro_claim_desc", Res.string.ab_intro_claim_desc)
  map.put("ab_intro_claim_placeholder", Res.string.ab_intro_claim_placeholder)
  map.put("ab_intro_claim_title", Res.string.ab_intro_claim_title)
  map.put("ab_intro_draft_desc", Res.string.ab_intro_draft_desc)
  map.put("ab_intro_draft_discard", Res.string.ab_intro_draft_discard)
  map.put("ab_intro_draft_resume", Res.string.ab_intro_draft_resume)
  map.put("ab_intro_draft_title", Res.string.ab_intro_draft_title)
  map.put("ab_intro_hero_a11y", Res.string.ab_intro_hero_a11y)
  map.put("ab_intro_hero_subtitle", Res.string.ab_intro_hero_subtitle)
  map.put("ab_intro_hero_title", Res.string.ab_intro_hero_title)
  map.put("ab_intro_learn_more", Res.string.ab_intro_learn_more)
  map.put("ab_intro_top_title", Res.string.ab_intro_top_title)
  map.put("ab_lang_autotranslate_hint", Res.string.ab_lang_autotranslate_hint)
  map.put("ab_lang_tab_a11y", Res.string.ab_lang_tab_a11y)
  map.put("ab_lang_will_translate", Res.string.ab_lang_will_translate)
  map.put("ab_loc_city_label", Res.string.ab_loc_city_label)
  map.put("ab_loc_city_placeholder", Res.string.ab_loc_city_placeholder)
  map.put("ab_loc_info", Res.string.ab_loc_info)
  map.put("ab_loc_map_adjust", Res.string.ab_loc_map_adjust)
  map.put("ab_loc_map_title", Res.string.ab_loc_map_title)
  map.put("ab_loc_pin_a11y", Res.string.ab_loc_pin_a11y)
  map.put("ab_loc_postal_label", Res.string.ab_loc_postal_label)
  map.put("ab_loc_postal_placeholder", Res.string.ab_loc_postal_placeholder)
  map.put("ab_loc_province_label", Res.string.ab_loc_province_label)
  map.put("ab_loc_province_placeholder", Res.string.ab_loc_province_placeholder)
  map.put("ab_loc_street_label", Res.string.ab_loc_street_label)
  map.put("ab_loc_street_placeholder", Res.string.ab_loc_street_placeholder)
  map.put("ab_location_title", Res.string.ab_location_title)
  map.put("ab_next", Res.string.ab_next)
  map.put("ab_photos_add_a11y", Res.string.ab_photos_add_a11y)
  map.put("ab_photos_brand_assets", Res.string.ab_photos_brand_assets)
  map.put("ab_photos_cover_hint", Res.string.ab_photos_cover_hint)
  map.put("ab_photos_cover_label", Res.string.ab_photos_cover_label)
  map.put("ab_photos_gallery_hint", Res.string.ab_photos_gallery_hint)
  map.put("ab_photos_gallery_label", Res.string.ab_photos_gallery_label)
  map.put("ab_photos_logo_button", Res.string.ab_photos_logo_button)
  map.put("ab_photos_logo_hint", Res.string.ab_photos_logo_hint)
  map.put("ab_photos_logo_label", Res.string.ab_photos_logo_label)
  map.put("ab_photos_preview_a11y", Res.string.ab_photos_preview_a11y)
  map.put("ab_photos_proof_button", Res.string.ab_photos_proof_button)
  map.put("ab_photos_proof_desc", Res.string.ab_photos_proof_desc)
  map.put("ab_photos_proof_note", Res.string.ab_photos_proof_note)
  map.put("ab_photos_proof_title", Res.string.ab_photos_proof_title)
  map.put("ab_photos_remove_a11y", Res.string.ab_photos_remove_a11y)
  map.put("ab_photos_subtitle", Res.string.ab_photos_subtitle)
  map.put("ab_photos_title", Res.string.ab_photos_title)
  map.put("ab_photos_verify_b1", Res.string.ab_photos_verify_b1)
  map.put("ab_photos_verify_b2", Res.string.ab_photos_verify_b2)
  map.put("ab_photos_verify_b3", Res.string.ab_photos_verify_b3)
  map.put("ab_photos_verify_desc", Res.string.ab_photos_verify_desc)
  map.put("ab_photos_verify_title", Res.string.ab_photos_verify_title)
  map.put("ab_plan_coming_soon", Res.string.ab_plan_coming_soon)
  map.put("ab_plan_footer", Res.string.ab_plan_footer)
  map.put("ab_plan_founding_note", Res.string.ab_plan_founding_note)
  map.put("ab_plan_free_cta", Res.string.ab_plan_free_cta)
  map.put("ab_plan_free_f1", Res.string.ab_plan_free_f1)
  map.put("ab_plan_free_f2", Res.string.ab_plan_free_f2)
  map.put("ab_plan_free_f3", Res.string.ab_plan_free_f3)
  map.put("ab_plan_free_f4", Res.string.ab_plan_free_f4)
  map.put("ab_plan_free_name", Res.string.ab_plan_free_name)
  map.put("ab_plan_free_price", Res.string.ab_plan_free_price)
  map.put("ab_plan_interest_recorded", Res.string.ab_plan_interest_recorded)
  map.put("ab_plan_intro", Res.string.ab_plan_intro)
  map.put("ab_plan_most_popular", Res.string.ab_plan_most_popular)
  map.put("ab_plan_notify_me", Res.string.ab_plan_notify_me)
  map.put("ab_plan_period_forever", Res.string.ab_plan_period_forever)
}
